<template>
    <div class="overview-package">
        <span class="overview-package__has-access" v-if="hasCourseAccess">
            <span v-html="getLearningPathInfoText"></span>
            <span class="icon-checked"></span>
        </span>
        <TotemCtaButton class="overview-package__no-access" :size="buttonSize" :url="$t('LearningPath.not_in_order_url')" v-if="isLoggedIn && !hasCourseAccess" :label="$t('LearningPath.not_in_order')" />
        <TotemCtaButton class="overview-package__trial" :size="buttonSize" url="trial" v-if="!isLoggedIn" :label="$t('CourseOverviewPackageInfo.trial_period')"/>
    </div>
</template>

<script>
    export default {
        props: {
            hasCourseAccess: Boolean,
            isLoggedIn: Boolean,
            isSubscribed: Boolean,
            isCompleted: Boolean
        },
        computed: {
            buttonSize () {
                if (this.isMobileView) {
                    return 'small'
                } else {
                    return 'medium'
                }
            },
            getLearningPathInfoText () {
                if (this.isSubscribed && !this.isCompleted) {
                    return this.$t('LearningPath.you_have_subscribed')
                } else if (!this.isSubscribed && !this.isCompleted) {
                    return this.$t('LearningPath.part_of_order')
                } else if (this.isCompleted) {
                    return this.$t('LearningPath.you_have_completed')
                }
                return ''
            }
        }
    }
</script>

<style lang="scss" scoped>
    .overview-package {

        [class*="desktop"] & {
            margin: 0;
            display: flex;
            justify-content: flex-end;
            flex: 1;
        }

        [class*="mobile"] & {
            display: flex;
            justify-content: center;
        }

        &__has-access {
            display: flex;
            align-items: center;
            color: $black;
            font-size: 1.6rem;
            @include white(background, 0.7);
            padding: 10px 15px 10px 20px;
            border-radius: 5px;
            min-height: 44px;
            height: 100%;

            [class*="mobile_sm"] & {
                font-size: 1.3rem;
                height: 33px;
            }
        }
        .icon-checked {
            font-size: 18px;
            margin: 0 0 0 10px;
            color: $ocean_green;

            [class*="mobile_sm"] & {
               line-height: 15px;
            }
        }

        &__no-access {

            [class*="desktop_lg"] & {
                font-size: 1.2rem !important;
            }

            [class*="desktop_l"] & {
                font-size: 1rem !important;
            }

            [class*="desktop_xl"] & {
                font-size: 1.2rem !important;
            }

            [class*="desktop_xxl"] & {
                font-size: 1.5rem !important;
            }

            [class*="mobile"] & {
                margin: 30px 0 0 0;
                align-items: center;
                display: flex;
            }
        }
        &__trial {

            [class*="mobile"] & {
                margin: 30px 0 0 0;
            }
        }
    }
</style>
